import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { ONBOARDING_ACTIVITY_CLASS } from '../../OnboardingTutorial/styles';

import { Maximized, type MaximizedProps } from './components/Maximized';
import { Minimized, type MinimizedProps } from './components/Minimized';

import { Wrapper } from './styles';

export type ActivityPanelProps = MaximizedProps &
    MinimizedProps & {
        show: boolean;
        addPadding?: boolean;
    };

export const ActivityPanel = ({
    show,
    handleToggle,
    collectionData,
    activityFeed,
    addingNewNotifications,
    newActivityCounter,
    notificationCount,
    notificationFeed,
    transitionFeed,
    collectionAddresses,
    activeWalletNumber,
    pastActivity,
    variant = 'detail-view',
    onIsScrolled,
    slug,
    addPadding,
    ...props
}: ActivityPanelProps) => {
    return (
        <>
            <AnimatePresence initial={false}>
                {show && (
                    <Wrapper $addPadding={addPadding} className={ONBOARDING_ACTIVITY_CLASS}>
                        <Maximized
                            collectionData={collectionData}
                            activityFeed={activityFeed}
                            newActivityCounter={newActivityCounter}
                            transitionFeed={transitionFeed}
                            pastActivity={pastActivity}
                            onIsScrolled={onIsScrolled}
                            collectionAddresses={collectionAddresses}
                            activeWalletNumber={activeWalletNumber}
                            slug={slug}
                            initial={{ y: 100, opacity: 0 }}
                            animate={{ y: 0, opacity: 1, transition: { ease: 'circOut', duration: 0.2 } }}
                            exit={{ y: 100, opacity: 0, transition: { ease: 'circIn', duration: 0.2 } }}
                            handleToggle={handleToggle}
                            variant={variant}
                            {...props}
                        />
                    </Wrapper>
                )}
            </AnimatePresence>

            <AnimatePresence>
                {!show && (
                    <Minimized
                        addingNewNotifications={addingNewNotifications}
                        notificationCount={notificationCount}
                        notificationFeed={notificationFeed}
                        initial={{ y: 100 }}
                        animate={{ y: 0, transition: { ease: 'circOut', duration: 0.2 } }}
                        exit={{ y: 100, transition: { ease: 'circIn', duration: 0.1 } }}
                        handleToggle={handleToggle}
                    />
                )}
            </AnimatePresence>
        </>
    );
};
